import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import AgentManagementAuthGuard from '../../components/auth/AgentManagementAuthGuard';
import SegmentsTable from '../../components/admin/agentManagement/SegmentsTable';
import AgentMqttTab, { mqttTabVisible } from '../../components/admin/agentManagement/AgentMqttTab';
import ErrorPanel from '../../components/common/ErrorPanel';
import { useAgentAuthorization } from '../../hooks/useAgentAuthorization';
import MainLayout from '../../components/layout/MainLayout';

/**
 * Agent Management Page - Segment-Centric View
 *
 * Segments are the primary objects; agents are shown inline within segments.
 */
const AgentManagementPage = () => {
  const { userRole, userTenant } = useAgentAuthorization();
  const [tab, setTab] = useState('agents');
  const showMqtt = mqttTabVisible(userRole);

  if (userRole === 'tenant_admin' && !userTenant) {
    return (
      <AgentManagementAuthGuard>
        <ErrorPanel
          title="Tenant Selection Required"
          message="Please select a tenant to manage agents. Contact your administrator if you don't have access to any tenants."
          variant="warning"
        />
      </AgentManagementAuthGuard>
    );
  }

  return (
    <MainLayout scrollMain>
      <AgentManagementAuthGuard>
        <Box
          sx={{
            maxWidth: '100%',
            mx: 'auto',
            px: { xs: 2, md: 3 },
            py: 2,
            boxSizing: 'border-box',
          }}
        >
          {showMqtt ? (
            <Tabs value={tab} onChange={(_event, value) => setTab(value)} sx={{ mb: 2 }}>
              <Tab value="agents" label="Agents" />
              <Tab value="mqtt" label="MQTT" />
            </Tabs>
          ) : null}
          {tab === 'mqtt' && showMqtt ? <AgentMqttTab /> : <SegmentsTable />}
        </Box>
      </AgentManagementAuthGuard>
    </MainLayout>
  );
};

export default AgentManagementPage;
